module.exports = __webpack_public_path__ + "static/media/timeline-step-7.e8225f63.png";